import { render, staticRenderFns } from "./NullDataPrompt.vue?vue&type=template&id=913a9682&scoped=true"
import script from "./NullDataPrompt.vue?vue&type=script&lang=js"
export * from "./NullDataPrompt.vue?vue&type=script&lang=js"
import style0 from "./NullDataPrompt.vue?vue&type=style&index=0&id=913a9682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913a9682",
  null
  
)

export default component.exports